import classNames from 'classnames'

import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import Button, { ButtonVariants } from '~/components/atoms/Button/Button'
import Container from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import Image from '~/components/atoms/Image/Image'
import Link from '~/components/atoms/Link/Link'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { resolveLink } from '~/components/serializers'
import { ComponentTheme } from '~/components/themes'
import { toURL } from '~/utils/urlResolver'

import styles from './MyPortfolioTextWithImage.module.css'

export interface MyPortfolioTextWithImageProps {
  introTitle?: string
  introText?: string
  // Card item
  cardPreTitle?: string
  cardTitle?: string
  cardText?: any
  cardButtonText?: string
  cardButtonFooterText?: string
  cardButtonFooterLinkText?: string
  cardButtonFooterLink?: any
  cardImage: any
  paddingRight?: boolean
  launchForm?: string
  launchAuthForm?: string
  mainLink?: any
}

export default function MyPortfolioTextWithImage({
  introTitle,
  introText,
  cardPreTitle,
  cardTitle,
  cardText,
  cardButtonText = 'Find out more',
  cardButtonFooterText,
  cardButtonFooterLinkText,
  cardButtonFooterLink,
  cardImage,
  paddingRight = false,
  launchForm,
  launchAuthForm,
  mainLink,
}: MyPortfolioTextWithImageProps) {
  return (
    <Fixture theme={ComponentTheme.secondary}>
      <div className={styles.base}>
        {introTitle && (
          <Container>
            <div className={styles.introContainer}>
              <Text
                size={TextSizes.primaryTitleLrg}
                className={styles.introTitle}
              >
                {introTitle}
              </Text>
              <Text size={TextSizes.bodyMed} className={styles.introText}>
                {introText}
              </Text>
            </div>
          </Container>
        )}
      </div>
      <div
        className={classNames(styles.cardContainer, {
          [styles.paddingRight]: paddingRight,
        })}
      >
        <Container className={!paddingRight ? 'noPaddingRight' : ''}>
          <div className={styles.card}>
            {/* Card Content */}
            <div className={styles.cardContent}>
              {cardPreTitle && (
                <Text
                  size={TextSizes.primaryTitleMed}
                  className={styles.cardPreTitle}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: cardPreTitle,
                    }}
                  />
                </Text>
              )}

              {cardTitle && (
                <Text
                  size={TextSizes.primaryTitleMed}
                  className={styles.cardTitle}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: cardTitle,
                    }}
                  />
                </Text>
              )}
              {cardText && (
                <div className={styles.cardText}>
                  <BlockContent
                    value={cardText}
                    size={TextSizes.bodyLrg}
                  ></BlockContent>
                </div>
              )}

              <Button
                variant={ButtonVariants.primaryDark}
                launchAuthForm={launchAuthForm}
                launchForm={launchForm}
                link={resolveLink(mainLink)}
                target={mainLink.target}
              >
                {cardButtonText}
              </Button>

              {cardButtonFooterText && cardButtonFooterLink && (
                <>
                  <div className={styles.contentFooter}>
                    {cardButtonFooterText && (
                      <Text
                        size={TextSizes.bodyMed}
                        className={styles.cardButtonFooterText}
                      >
                        {cardButtonFooterText}
                      </Text>
                    )}

                    {cardButtonFooterText && cardButtonFooterLink && (
                      <Link
                        href={toURL(cardButtonFooterLink.url)}
                        noPrefetch
                        className={styles.cardButtonFooterLink}
                      >
                        <Text size={TextSizes.bodyMed}>
                          {cardButtonFooterLinkText}
                        </Text>
                      </Link>
                    )}
                  </div>
                </>
              )}
            </div>

            {/* Image Container */}
            {}
            <div className={styles.imageContainer}>
              {cardImage && (
                <div className={styles.imageWrapper}>
                  <Image
                    asset={cardImage.asset}
                    alt={cardImage.alt}
                    width={700}
                    objectFit="contain"
                  />
                </div>
              )}
            </div>
          </div>
        </Container>
      </div>
    </Fixture>
  )
}
